import React from "react";
import { Link } from "react-router-dom";
import useMenuLogic from "./Menu.logic";

const Menu: React.FC = () => {
  const {
    isCurrentPath,
    isAuthenticated,
    showEventAttended,
    showEventVolunteered,
    showEventHosted,
    showAdminMenu,
  } = useMenuLogic();

  return (
    <ul className="main-menu__list">
      {showAdminMenu ? (
        <>
          <li className={`${isCurrentPath("/admin", true) ? "current" : ""}`}>
            <Link to="/admin">Admin Dashboard</Link>
          </li>
          <li
            className={`${isCurrentPath("/admin/manage") ? "current" : ""
              } dropdown`}
          >
            <Link to="#">Manage</Link>
            <ul>
              <li
                className={`${isCurrentPath("/admin/manage/ngos") ? "current" : ""
                  }`}
              >
                <Link to="/admin/manage/ngos">NGOs</Link>
              </li>
              <li>
                <Link to="/admin/manage/interests">Interests</Link>
              </li>
              <li>
                <Link to="/admin/manage/causes">Causes</Link>
              </li>
            </ul>
          </li>
        </>
      ) : (
        <>
          <li className={`${isCurrentPath("/") ? "current" : ""}`}>
            <Link to="/">Home</Link>
          </li>
          <li
            className={`${(isCurrentPath("/events") ? "current" : "") +
              (isAuthenticated ? " dropdown" : "")
              }`}
          >
            <Link to="/events">Events</Link>
            {isAuthenticated && (
              <>
                <ul>
                  <li>
                    <Link to="/events?filter=discover">Discover</Link>
                  </li>
                  {showEventAttended && (
                    <li>
                      <Link to="/events?filter=attended">
                        Joined as Attendee
                      </Link>
                    </li>
                  )}
                  {showEventVolunteered && (
                    <li>
                      <Link to="/events?filter=volunteered">
                        Joined as Volunteer
                      </Link>
                    </li>
                  )}
                  {showEventHosted && (
                    <li>
                      <Link to="/events?filter=hosted">Hosted by You</Link>
                    </li>
                  )}
                  <li>
                    <Link to="/events/add">Host a New Event</Link>
                  </li>
                </ul>
              </>
            )}
          </li>
          <li className={`${isCurrentPath("/ngos") ? "current" : ""}`}>
            <Link to="/ngos">NGOs</Link>
          </li>
          <li>
            <Link to="/about">About Us</Link>
          </li>
          {/* <li>
            <Link to="/contact">Contact Us</Link>
          </li> */}
        </>
      )}
    </ul>
  );
};

export default Menu;
